import {Module} from 'vuex'

const getOriginalState = () => {
  return {
    communes: [],
    voies: [],
    zones: [],
    gedConsultationUrl: null
  }
}

export const referentielStore: Module<any, any> = {
  namespaced: true,
  state: getOriginalState(),
  mutations: {
    setReferentiel(state, referentiel) {
      state.communes = referentiel.communes
      state.zones = referentiel.zones
      state.gedConsultationUrl = referentiel.gedConsultationUrl
    },
    setVoiesCommune(state, voies) {
      state.voies = voies
    },
    reinitialiser(state) {
      Object.assign(state, getOriginalState())
    }
  }
}
